<template>
  <div class="party-mass-work-page">
    <!-- 页面顶部导航 -->
    <AppHeader />

    <!-- 顶部视频 Banner：布局与首页主视频区保持一致 -->
    <main class="main-content">
      <img :src="require('@/assets/images/PartyMassWork/title.png')" alt="党群建设" class="hero-bg" />
      <!-- <div class="text-content">
        <h1>党群建设</h1>
        <p>凝心聚力，共促发展</p>
      </div> -->
    </main>

    <section class="party-section">
      <div class="party-container">
        <div class="party-section__header">
          <h2 class="party-section__title">工作动态</h2>
          <div class="module-underline"></div>
          <p class="party-section__desc">展示党群建设重点工作与活动。</p>
        </div>

        <!-- 列表卡片：复用首页产品卡片的布局结构与 hover 交互 -->
        <div class="party-list">
          <dl class="product-card" v-for="(item, index) in partyCards" :key="item.title"
            :class="{ 'reverse-layout': index % 2 === 1 }" @click="navigateToParty(item)">
            <div class="product-content">
              <dt class="product-img-container">
                <img :src="item.image" :alt="item.title" class="product-img" />
              </dt>
              <dd class="product-text">
                <h3 class="product-title">{{ item.title }}</h3>
                <p class="product-desc">{{ item.description }}</p>
                <button class="card-arrow" type="button">&gt;</button>
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </section>

    <!-- 页面底部 -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'

export default {
  name: 'PartyMassWork',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      // 页面卡片数据
      partyCards: [
        {
          id: '1',
          title: '党支部成立 激活基层治理新动能',
          description: '为进一步加强基层党组织建设，充分发挥党建引领作用，中共合肥千手医疗科技有限责任公司支部委员会正式成立。新党支部的成立，有效整合了社区治理资源，完善了组织架构，为推动社区精细化治理、解决群众急难愁盼问题提供了坚强的组织保障，激活了基层治理的新动能。',
          image: require('@/assets/images/PartyMassWork/PartyBranch/PartyBranch3.jpg')
        },
        {
          id: '2',
          title: '董事长陈佩红、党支部书记李春发参加高新区“先锋淬炼”示范培训班',
          description: '2025年12月17日至19日，我司董事长陈佩红、党支部书记李春发全程参加合肥高新区“先锋淬炼”系列课（第3期）——新兴领域“强党建、促发展”示范培训班。本次培训聚焦理论武装、实务赋能与经验交流，涵盖政策解读、实地观摩、专家授课等内容，进一步提升了我司党建工作水平，为党建引领企业高质量发展注入新动能。学以致用、知行合一，我司将持续深化党建与业务融合，奋力书写“党建强、发展强”的新篇章。',
          image: require('@/assets/images/PartyMassWork/SymposiumMC/SymposiumMC1.jpg')
        },
        {
          id: '3',
          title: '党建惠民送祝福 情暖梦城社区',
          description: '秉持党建惠民的理念，党支部组织党员志愿者走进梦城社区，开展形式多样的送祝福活动。活动中，党员们与社区居民亲切交流，倾听群众心声，为居民送上节日的问候与美好祝愿，用实际行动拉近党群关系，让党组织的温暖真正走进社区、温暖人心。',
          image: require('@/assets/images/PartyMassWork/DeliveringBlessings/DeliveringBlessings1.jpg')
        },
        {
          id: '4',
          title: '福字传情 党支部践行初心使命',
          description: '为弘扬中华优秀传统文化，践行党员的初心使命，党支部开展福字赠送活动。党员们亲手书写福字，将承载着吉祥寓意的福字送到全体员工手中，不仅为公司增添了浓厚的节日氛围，更以这种接地气的方式，表达了对全体员工的美好祝福，彰显了党支部服务同事、心系民生的责任与担当。',
          image: require('@/assets/images/PartyMassWork/SendingBlessingsMC/SendingBlessingsMC2.jpg')
        },

      ]
    }
  },
  methods: {
    navigateToParty(item) {
      if (item?.route) {
        window.scrollTo(0, 0)
        this.$router.push(item.route)
        return
      }
      if (item?.externalUrl) {
        window.open(item.externalUrl, '_blank')
        return
      }

      window.scrollTo(0, 0)
      this.$router.push({
        name: 'PartyMassWorkDetail',
        query: {
          id: item?.id,
          title: item?.title || '党群建设'
        }
      })
    }
  }
}
</script>

<style scoped>
@import url(../../style/PartyMassWork/PartyMassWork.css);
</style>
